import axios from "../axios";
const handleLoginApi = (email, password) => {
    // console.log("hello from HandleLoginApi");
    return axios.post('/api/login', { email, password }); // nhu nay nghia "email: email input", "password: password input" de khop voi User.email ben Nodejs
}
const getAllUsers = (inputid) => {
    // su dung cu phap cua template string
    return axios.get(`/api/get-all-users?id=${inputid}`);
    // return axios.get('/api/get-all-user', {
    //     data: {
    //         id: inputid
    //     }
    // });

}
const createNewUserService = (data) => {
    // console.log("hello from createNewUser Service:", DataTransfer);
    return axios.post('/api/create-new-user', data)
}
const deleteUserService = (data) => {
    // console.log("hello from createNewUser Service:", DataTransfer);
    // return axios.delete('/api/delete-user', data)
    return axios.delete('/api/delete-user', {
        data: {
            id: data.id
        }
    });
}
const editUserService = (data) => {
    console.log("hello from editUserService Service:", data.id);
    return axios.put('/api/edit-user', data);

}
export {
    handleLoginApi,
    getAllUsers,
    createNewUserService,
    deleteUserService,
    editUserService
}